import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  justify-content: space-between;
  align-items: center;

  ${props => props.theme.breakpoints.between("tablet", "homeDesktop")} {
    flex-wrap: wrap;
    gap: 12px;
  }
`;

export const TitleAndDetailsContainer = styled.div``;

export const Title = styled.div`
  margin-block-end: 8px;

  font-weight: 700;
  font-size: 14px;
`;

export const SubscribeDetails = styled.div`
  font-weight: 400;
  font-size: 14px;
`;

export const ButtonContainer = styled.div`
  button {
    padding-block: 10px !important;
    padding-inline: 16px !important;

    font-family: ${fontRoboto};
  }
`;
